import { render } from "./PaisesModal.vue?vue&type=template&id=6622e53b"
import script from "./PaisesModal.vue?vue&type=script&lang=js"
export * from "./PaisesModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__